import { useEffect } from 'react';
var P3Link = function P3Link(_ref) {
  var page = _ref.page;
  var thisPage = 5;
  useEffect(function () {
    $('.p3-link').css({
      opacity: page === thisPage ? 1 : 0
    });
  }, [page]);
  return /*#__PURE__*/React.createElement("div", {
    className: "p3-link"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p3/link-2@3x.png",
    className: "p3-link__2"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p3/link-1@3x.png",
    className: "p3-link__1"
  }));
};
export default P3Link;